import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  readORhead: {
    cursor: 'pointer',
    marginLeft: '10px',
    fontSize: '12px',
    color: '#096bdf'
  },
  text: {
    inlineSize: '100%',
    overflowWrap: 'break-word',
    fontSize: '14px',
    fontFamily: 'Raleway, sans-serif'
  }
}));
export default function ReadMore({ children, nbrCara, colorText }) {
  const classes = useStyles();
  const text = children;
  const [isReadMore, setIsReadMore] = React.useState(true);
  const isArabic = /[\u0600-\u06FF\u0750-\u077F]/;

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  const textLength = text.length;
  return (
    <div
      className={classes.text}
      style={{ color: colorText, textAlign: !isArabic.test(text) ? 'left' : 'right' }}
    >
      {isReadMore ? text.slice(0, nbrCara) : text}
      {textLength > nbrCara && (
        <Typography onClick={toggleReadMore} className={classes.readORhead}>
          {isReadMore ? '...read more' : ' show less'}
        </Typography>
      )}
    </div>
  );
}
